import http from '../../http';
import { SERVER_URL } from '../../config';

export const getPersonData = (params) => http.get(`${SERVER_URL}/api-main/v1/person`, { params: { ...params } });
export const getPersonalListData = () => http.get(`${SERVER_URL}/api-main/v1/personal`, {});
